import { ServiceName, ServicesHeading, ServicesSection } from "./services-parts";
import type { ServicesLayoutProps } from "./services-parts";
import { serviceKey } from "./services-text";

/**
 * The service names in one centred, wrapping line, each after a dot in the brand color and linked
 * to its page when it has one. Nine services read as three short rows instead of nine cards.
 * @param {ServicesLayoutProps} props The section's props.
 * @returns {React.JSX.Element} The section.
 */
const ServicesCompact = ({ id, className, heading, subheading, services, backgroundColor }: ServicesLayoutProps): React.JSX.Element => (
  <ServicesSection id={id} className={className} backgroundColor={backgroundColor}>
    <ServicesHeading heading={heading} subheading={subheading} />
    <ul
      data-testid="services-compact"
      className="jobsite:mx-auto jobsite:flex jobsite:max-w-4xl jobsite:flex-wrap jobsite:items-center jobsite:justify-center jobsite:gap-x-6 jobsite:gap-y-3 jobsite:text-lg jobsite:font-medium jobsite:text-foreground jobsite:md:text-xl"
    >
      {(services ?? []).map((service) => (
        <li key={serviceKey(service)}>
          <ServiceName service={service} />
        </li>
      ))}
    </ul>
  </ServicesSection>
);

export { ServicesCompact };
